import { graphql } from "gatsby"
import React, { useContext } from "react"
import Slider from "react-slick"
import { css } from "styled-components"
import { UIContext } from "../../components/shared/layout"
import Grid from "../atoms/layout-primitives/grid"
import VariantContainer from "../atoms/variant-container"
import UseCaseCard, { IUseCaseCard } from "../molecules/use-case-card"
import {
  BackgroundColourContextProvider,
  isDarkColour,
} from "../util/background-colour-context"

export const USE_CASE_CARDS_TYPENAME = "ContentfulUseCaseList"
export interface IUseCaseCards {
  __typename: typeof USE_CASE_CARDS_TYPENAME
  useCases: IUseCaseCard[]
  backgroundColour: { hex: string }
}

const UsecaseCards = ({
  useCases,
  backgroundColour,
}: Omit<IUseCaseCards, "__typename">) => {
  const {
    state: { breakpoint, clientLoaded },
  } = useContext(UIContext)

  return (
    useCases &&
    Array.isArray(useCases) && (
      <BackgroundColourContextProvider colour={backgroundColour?.hex}>
        <Grid>
          <VariantContainer
            variants={[
              css`
                box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.07);
                border-radius: 2px;
                grid-column: 1 / -1;
                .slick-dots {
                  bottom: -40px;
                }
                ${isDarkColour(backgroundColour?.hex || "")
                  ? css`
                      .slick-dots li button:before {
                        color: var(--white);
                      }
                    `
                  : null}
              `,
              css`
                grid-column: 2 / -2;
                margin-left: 3.01%;
                margin-right: 3.01%;
              `,
              css`
                grid-column: 1 / -1;
                margin-left: auto;
                margin-right: auto;
                border-radius: 4px;
              `,
            ]}
          >
            {breakpoint === "lg" ? (
              <VariantContainer>
                {useCases.map((card, index) => (
                  <UseCaseCard {...card} key={index} />
                ))}
              </VariantContainer>
            ) : (
              clientLoaded && (
                <Slider dots arrows={false}>
                  {useCases.map((card, index) => (
                    <UseCaseCard {...card} key={index} />
                  ))}
                </Slider>
              )
            )}
          </VariantContainer>
        </Grid>
      </BackgroundColourContextProvider>
    )
  )
}

export const UseCaseCardsFragment = graphql`
  fragment ContentfulUseCaseList on ContentfulUseCaseList {
    __typename
    useCases {
      ... on ContentfulUseCaseCard {
        ...ContentfulUseCaseCard
      }
    }
    backgroundColour {
      hex
    }
  }
`
export default UsecaseCards
